export default __webpack_public_path__ + "static/media/terraform_logo.95fb64ad.svg";